"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.IconContainer = exports.ButtonContainer = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(3),
  padding: theme.spacing(6, 3),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(6)
  }
}));
const IconContainer = exports.IconContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '8rem',
  justifySelf: 'stretch',
  color: theme.palette.error.dark
}));
const ButtonContainer = exports.ButtonContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  marginTop: theme.spacing(3),
  width: '100%'
}));